import axios from "axios";

export async function getCountry(query = "") {
  try {
    const res = await axios.get("/material-countries", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getBrand(query = "") {
  try {
    const res = await axios.get("/material-brands", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getMaterialConditions(query = "") {
  try {
    const res = await axios.get("/material-conditions", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getFactory(query = "") {
  try {
    const res = await axios.get("/material-factories", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getKontrak(query = "") {
  try {
    const res = await axios.get("/kontrak-materials", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getSatuan(query = "") {
  try {
    const res = await axios.get("/material-units", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}

export async function getKontak(query = "") {
  try {
    const res = await axios.get("/contact-persons", {
      params: {
        search: query,
      },
    });
    return res.data.data.data;
  } catch (error) {
    console.error("Error loading options:", error);
    return [];
  }
}


